import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Result, Spin } from 'antd';
import { supabase } from './supabaseClient';

const AcceptInvitation = ({ user }) => {
    const { invitationId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const acceptInvitation = async () => {
            if (!user) {
                setError("Please log in to accept the invitation");
                setLoading(false);
                return;
            }

            try {
                // 먼저 초대장 정보를 가져옵니다
                const { data: invitation, error: fetchError } = await supabase
                    .from('invitations')
                    .select('*')
                    .eq('id', invitationId)
                    .single();

                if (fetchError) throw fetchError;
                if (!invitation) throw new Error('Invitation not found');

                // 초대장의 대상 이메일과 현재 로그인한 사용자의 이메일이 일치하는지 확인
                if (invitation.target_email !== user.email) {
                    throw new Error('This invitation was sent to a different email address');
                }

                // 이미 처리된 초대장인지 확인
                if (invitation.status !== 'pending') {
                    throw new Error('This invitation has already been processed');
                }

                // 초대장 상태 업데이트
                const { error: updateError } = await supabase
                    .from('invitations')
                    .update({
                        status: 'accepted',
                        accepted_at: new Date().toISOString()
                    })
                    .eq('id', invitationId)
                    .eq('target_email', user.email); // 추가 안전장치

                if (updateError) throw updateError;

                // 미팅 페이지로 리다이렉트
                navigate(`/meeting/${invitation.meeting_id}`);
            } catch (err) {
                console.error('Error accepting invitation:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        acceptInvitation();
    }, [invitationId, navigate, user]);

    if (!user) {
        return (
            <Result
                status="warning"
                title="Authentication Required"
                subTitle="Please log in to accept the invitation"
            />
        );
    }

    if (loading) {
        return <Spin size="large" />;
    }

    if (error) {
        return (
            <Result
                status="error"
                title="Failed to accept invitation"
                subTitle={error}
            />
        );
    }

    return null;
};

export default AcceptInvitation;